import { Component, ViewChild, OnInit, ElementRef, AfterContentChecked } from '@angular/core';
import { SidenavService } from './services/sidenav.service';
import { onMainContentChange } from './animations/animations';
import { MatSidenav } from '@angular/material/sidenav';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { AuthService } from './services/auth.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { Organization } from './interfaces/organization-info.interface';
import { User } from './models/user.model';
import { Course } from './models/course.model';
import { ButtonAction } from './models/button-action.model';
import { Category } from './models/category.model';
import { SpinnerService } from './services/spinner.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [onMainContentChange],
  queries: { "mainContainer": new ViewChild("mainContainer") }
})
export class AppComponent implements OnInit, AfterContentChecked {

  isMobile: boolean = false;
  buttonAction: ButtonAction;

  public onSideNavChange: boolean = true;

  @ViewChild('leftSidenav', { read: MatSidenav }) leftSidenav: MatSidenav;

  childComponent: any;

  navMode = 'side';
  returnUrl: string;

  breadcrumbs: string[] = [];

  user: User;
  mainOrganization: Organization;
  organizations: Organization[];

  public mainContainer!: ElementRef;

  constructor(
    private _sidenavService: SidenavService,
    private auth: AuthService,
    private spinner: SpinnerService,
    private watcher: MediaObserver,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this._sidenavService.sideNavState$.subscribe(res => {
      this.onSideNavChange = res;
    });
  }

  ngOnInit() {

    if (this.watcher.isActive('xs') || this.watcher.isActive('sm')) {
      this.navMode = 'over';
    }

    this.watcher.media$
      .subscribe((change: MediaChange) => {
        switch (change.mqAlias) {
          case 'xs':
            this.isMobile = true;
            this.navMode = 'over';
            this.leftSidenav ? this.leftSidenav.close() : null;
            break;
          case 'sm':
            this.isMobile = true;
            this.navMode = 'over';
            this.leftSidenav ? this.leftSidenav.close() : null;
            break;
          default:
            this.isMobile = false;
            this.navMode = 'side';
            this.leftSidenav ? this.leftSidenav.open() : null;
            break;
        }
      });

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.route),
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        mergeMap((route) => route.data))
      .subscribe((route: ActivatedRoute) => {
        this.breadcrumbs = this.createBreadcrumbs(route);
        this.buttonAction = this.setActionButton(route);
        if (this.mainContainer) {
          this.mainContainer.nativeElement.scrollTo(0, 0);
        }
      });

  }

  ngAfterContentChecked() {
    if (!this.user || !this.organizations || !this.mainOrganization) {
      this.user = this.auth.currentUser;
      this.organizations = this.auth.currentOrganizations;
      this.mainOrganization = this.auth.currentMainOrganization;
    }
  }

  public get isLoggedIn(): boolean {
    return this.auth.isLoggeIn;
  }

  createBreadcrumbs(route: ActivatedRoute): string[] {
    return route['breadcrumb'];
  }

  setActionButton(route: ActivatedRoute) {
      return route['buttonAction'];
  }

  makeAction() {
    if (this.childComponent.action === 'CREATE_LESSON') {
      this.childComponent.createLesson();
    } else if (this.childComponent.action === 'CREATE_ACTIVITY') {
      this.childComponent.createActivity();
    } else if (this.childComponent.action === 'CREATE_COURSE') {
      this.childComponent.createCourse();
    } else if (this.childComponent.action === 'GO_TO_EDIT_LESSON') {
      this.childComponent.goToEditLesson();
    } else if (this.childComponent.action === 'GO_TO_EDIT_ACTIVITY') {
      this.childComponent.goToEditActivity();
    } else if (this.childComponent.action === 'GO_TO_EDIT_COURSE') {
      this.childComponent.goToEditCourse();
    }
  }

  onActivate(ev: any) {
    console.log(ev);
    this.childComponent = ev;
  }
}
